export default "__VITE_ASSET__ada9a03e__"